import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import '@/plugins/antd'
import $axios from '@/plugins/axios'
import '@/utils/zhuge'
import zhugePoint from '@/utils/zhugePoint'

import Share from 'vue-social-share'
import '@/assets/client.css';
import '@/assets/iconfont/iconfont.css';

// VMdPreview
import VMdPreview from '@kangc/v-md-editor/lib/preview';
import '@kangc/v-md-editor/lib/style/preview.css';
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js';
import '@kangc/v-md-editor/lib/theme/style/github.css';

// highlightjs
import hljs from 'highlight.js';

VMdPreview.use(githubTheme, {
  Hljs: hljs,
});
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
  // 需要配置的属性 注意属性并没有引号
  title: false,
  toolbar: true,
})

Vue.use(VMdPreview);

Vue.use(zhugePoint)
Vue.use(Share)

Vue.prototype.$axios = $axios;
Vue.config.productionTip = false
let global = {
  userid: '', //用户id
  enterTime: new Date(), //用户进入时间
  count: 0, //全局阅读文章数
}
Vue.prototype.GLOBAL = global
new Vue({
  router,
  render: h => h(App),
  beforeDestroy(){
    console.log("macc-help-文档中心-用户统计,this.GLOBAL.count",this.GLOBAL.count);
    // 发送诸葛io埋点数据
    this.zhugePoint("macc-help-文档中心-用户统计", {
      userid: this.GLOBAL.userid, //用户id
      enterTime: this.GLOBAL.enterTime, //用户进入文档系统的时间
      outTime: new Date(), //用户离开文档系统的时间
      count: this.GLOBAL.count, //全局阅读文章数
    });
  }
}).$mount('#app')